import { render, staticRenderFns } from "./cmsCategories.vue?vue&type=template&id=06c7e896&scoped=true&"
import script from "./cmsCategories.vue?vue&type=script&lang=ts&"
export * from "./cmsCategories.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06c7e896",
  null
  
)

export default component.exports